import { forwardRef, type Ref, type SVGProps } from "react";

function SvgShare(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 21 20" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10.75 2v11.25m0-11.25 4.5 4.5M10.75 2l-4.5 4.5M19 11v4.5a3 3 0 0 1-3 3H5.5a3 3 0 0 1-3-3V11"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgShare);
export default ForwardRef;
